module.exports = __webpack_public_path__ + "img/allergens-1.27cce302.png";